<template>
  <el-cascader :ref="refs" placeholder="请选择" :popper-class="refs" @visible-change="visibleChange" @expand-change="visibleChange" :disabled="disabled" :options="datas" :props="props" v-model="ids" @change="checkChange" :show-all-levels="showAllLevels" :clearable="clearable"></el-cascader>
</template>

<script>
import { regionData } from 'element-china-area-data'
export default {
  props: {
    value: "",
    showAllLevels: {
      type: Boolean,
      default: true,
    },
    config: {
      type: Object,
      default: () => { return {} },
    },
    root: 0,
    clearable: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    defaultDisabled: {
      type: Array,
      default: () => { return [] },
    },
    default: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      datas: [],
      checkedKeys: [],
      ids: "",
      props: {
        checkStrictly: false,
        value: "value",
      },
    }
  },
  watch: {
    value: function (newValue) {
      this.ids = newValue;
      if (this.ids) {
        this.checkChange(this.ids)
      }
    },
    defaultDisabled() {
      this.setChildren(this.datas);
    },
  },
  created() {
    this.props = Object.assign(this.props, this.config);
    this.refs = "region_" + new Date().getTime();
  },
  mounted() {
    this.ids = this.value;
    this.getData();
  },
  methods: {
    getData() {
      this.datas = regionData;
    },
    setChildren(arr) {
      arr.map(item => {
        item.childrens = item.children || [];
        if (this.defaultDisabled.indexOf(item.id) >= 0) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
        if (item.children && item.children.length > 0) {
          if (this.default && item.type == this.type && (!this.ids || this.ids.length == 0) && !this.target) {
            this.ids = item.id;
            this.$emit('change', item);
          }
          let childType = item.children[0].type;
          if (childType > this.type) {
            item.children = null;
          } else {
            if (!this.props.checkStrictly) {
              item.children = item.children || [];
            }
          }
        }
        if (item.children && item.children.length > 0) {
          this.setChildren(item.children);
        }
      })
    },
    checkChange(val) {
      let checkedNodes = this.$refs[this.refs].getCheckedNodes();
      let datas = [];
      checkedNodes.map(item => {
        if(item){
          datas.push(item.data);
        }
      })
      if (this.props.multiple) {
        this.$emit('input', val);
        this.$emit("change", datas);
      } else {
        let id = "";
        if (val instanceof Array) {
          id = val[val.length - 1]
        } else {
          id = val;
        }
        this.$emit('input', id);
        let checkedNodes = this.$refs[this.refs].getCheckedNodes();
        let node = checkedNodes.find(item => item.data.value == id);
        if (node) {
          node.data.path = this.func.depCopy(node.path);
          node.data.pathLabels = this.func.depCopy(node.pathLabels);
          this.$emit('change', node.data);
        }
      }
    },
    visibleChange(val) {
      if (this.props.checkStrictly && val) {
        setTimeout(() => {
          var depts = document.getElementsByClassName(this.refs)[0];
          var btns = depts.getElementsByClassName('el-radio__inner');
          for (let i = 0; i < btns.length; i++) {
            btns[i].onclick = () => {
              this.$refs[this.refs]._data.dropDownVisible = false;
            }
          }
        }, 200);
      }
    },
  },
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/RegionTree.vue